<template>
  <q-drawer
    v-if="drawerIf"
    ref="drawer"
    :content-class="contentClass"
    :content-style="drawerOffset"
    no-swipe-open
    overlay
    :side="side"
    :value="isOpen"
    :width="width"
    @before-show="detectOffset"
    @hide="$emit('close')"
  >
    <slot />
  </q-drawer>
  <div v-else>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ResponsiveDrawer',
  props: {
    contentClass: String,
    contentStyle: [String, Object],
    drawerIf: Boolean,
    noHeaderSpace: Boolean,
    noSwipeOpen: Boolean,
    side: String,
    width: Number,
  },
  data() {
    return {
      drawerOffset: { paddingTop: 0 },
      isOpen: false,
    };
  },
  methods: {
    close() {
      if (this.$refs.drawer) {
        this.$refs.drawer.hide();
      }
    },
    detectOffset() {
      if (!this.noHeaderSpace) {
        const height = document.getElementById('mainHeader').offsetHeight;
        this.drawerOffset.paddingTop = `${height}px`;
      }
    },
    open() {
      this.$refs.drawer.show();
      this.$emit('open');
    },
  },
};
</script>
